import React, {useEffect, useRef, useState} from "react";
import {getCMFWListFI, getCMFWListInfoRead, getFloor} from "../../api/apiClient";
import {Col, Row} from "react-bootstrap";
import AxcCanvas from "../../components/control/AxcCanvas";
import StatusInfo from "../../pages/subPages/StatusInfo";
import PopUp from "../../components/popUp/PopUp";
// import FcltyFloorSelector from "./FcltyFloorSelector";
import FcltyFloorSelectorV2 from "./FcltyFloorSelector_V2";
import Button from "react-bootstrap/Button";


const FcltyFloorCtl = ({
                         propFcltyID,
                         propIsReadOnly,
                         propLocation
                       }) => {

  const [fcltyFloorList, setFcltyFloorList] = useState([]);
  const [selectedFloorIdx, setSelectedFloorIdx] = useState(0);
  const [deviceList, setDeviceList] = useState([]);

  const [stFloorImg, setFloorImg] = useState();

  const updateFloorList = () => {
    if (propFcltyID != null) {
      getCMFWListFI(propFcltyID).then(response => {
      //getCMFWListInfoRead(propFcltyID).then(response => {
        console.log(response.data.data.floorsList);
        setFcltyFloorList(response.data.data.floorsList);
      });
    }
  };

  useEffect(() => {
    console.log(fcltyFloorList);
  }, [fcltyFloorList]);


  useEffect(() => {
    updateFloorList();

  }, []);


  useEffect(() => {
    if (fcltyFloorList) {
      if (fcltyFloorList.length > 0) {
        if (fcltyFloorList[selectedFloorIdx] !== undefined) {
          setFloorImg(`data:image/png;base64,${fcltyFloorList[selectedFloorIdx].image_data}`);
        }
        getFloor(propFcltyID, fcltyFloorList[selectedFloorIdx]?.fclty_dtl_no).then(res => {
          setDeviceList(res.data.data.pointsList);
        })
      }
    }
  }, [fcltyFloorList, selectedFloorIdx]);

  useEffect(() => {
    updateMarkerList();
  }, [deviceList])

  const [stMarkerList, setMarkerList] = useState([]);
  const updateMarkerList = () => {
    let markerList = [];
    // eslint-disable-next-line array-callback-return
    deviceList.map((elem) => {
      if (elem.x_crdnt != null) {
        AddMarkerWithXY(elem, markerList);
      }
    });
    setMarkerList(markerList);
  }

  const AddMarkerWithXY = (elem, markerList) => {
    let color = 'f79646';
    let status;
    if (elem.fire_sttus === 0 || elem.fire_sttus === undefined) {
      status = elem.serius_level === 0 ? 'Normal' : elem.serius_level === 1 ? 'Minor' :
            elem.serius_level === 2 ? 'Major' : 'Crit';
    }
    else {
      status = 'Fire';
    }

    console.log(elem);
    markerList.push({
      id: elem.device_ty === 2 ? `R${elem.rpeat_no}` : `${elem.sensor_no}`,
      rpeat_no: elem.rpeat_no,
      type: elem.device_ty === 1 ? 'gateway' : elem.device_ty === 2 ? 'Rep' :
          elem.device_ty === 3 ? 'Fire' : elem.device_ty === 4 ? 'Motion' : 'Bell',
      status: status,
      color: color,
      x: elem.x_crdnt,
      y: elem.y_crdnt,
      setup_yn: 'Y'
    });
  };

  /* 팝업을 위한 state */
  const [openPopup, setPopup] = useState({isVisible: false, user_id: 0});

  const closePopup = () => {
    setPopup({
      isVisible: false,
      type: 'gateway',
      id: 0,
    });
  };

  const handleOpenPopup = (type, id, rpeat_no) => {
    setPopup({
      isVisible: true,
      type: type,
      id: id,
      rpeat_no: rpeat_no
    });
  };

  const onClickMarker = (e) => {
    const id = e.target.id();
    for (let i = 0; i < stMarkerList.length; i++) {
      if (stMarkerList[i].id === id) {
        handleOpenPopup(stMarkerList[i].type, id, stMarkerList[i].rpeat_no);
      }
    }
  };

  const refImagePanel = useRef()
  const refStage = useRef();

  return (
      <Row className={"floor-plan-container p-0 mt-3"}>
        <PopUp
            propTitle={'상태 정보'}
            propShow={openPopup.isVisible}
            setShow={closePopup}
        >
          {/*게이트웨이*/}
          <StatusInfo
              propType={openPopup.type}
              propName={'게이트웨이'}
              propFcltyID={propFcltyID}
              propRpeatNo={openPopup.rpeat_no}
              propSensorNo={openPopup.id}
          />
        </PopUp>
        <Col md={9} className={"floor-plan-image-container"}>
          <Row ref={refImagePanel}>
          {propIsReadOnly ?
              <>
                <AxcCanvas
                    propImageSrc={stFloorImg}
                    //propWidth={refImagePanel.current ? refImagePanel.current.offsetWidth - 20 : 0}
                    propWidthRef={refImagePanel}
                    propWidthMargin={20}
                    propHeight={500}
                    propMarkerList={stMarkerList}
                    draggable={false}
                    onClickMarker={onClickMarker}
                    refStage={refStage}
                />
              </> :
              <>
                <AxcCanvas
                    propImageSrc={stFloorImg}
                    //propWidth={refImagePanel.current ? refImagePanel.current.offsetWidth - 20 : 0}
                    propWidthRef={refImagePanel}
                    propWidthMargin={20}
                    propHeight={500}
                    propMarkerList={stMarkerList}
                    draggable={false}
                    onClickMarker={onClickMarker}
                    refStage={refStage}
                />
                {/*<Button*/}
                {/*    className={'floor-plan-image-container__btn py-2'}*/}
                {/*    onClick={(e) => {*/}
                {/*      console.log(e);*/}
                {/*      console.log(fcltyFloorList[selectedFloorIdx]);*/}
                {/*    }}*/}
                {/*>*/}
                {/*  도면 수정*/}
                {/*</Button>*/}
              </>
          }

          </Row>
        </Col>
        <Col md={3} className={'floor-control-container'}>
          <FcltyFloorSelectorV2
              propFcltyID={propFcltyID}
              propFcltyFloorList={fcltyFloorList}
              propSetFlctyFloorList={setFcltyFloorList}
              propSelectedFloorIdx={selectedFloorIdx}
              propIsReadOnly={propIsReadOnly}
              setSelectedFloorIdx={setSelectedFloorIdx}
              updateList={updateFloorList}
              propLocation={propLocation}
          />
        </Col>
      </Row>
  );
}

export default FcltyFloorCtl;
